import { useLazyQuery, useMutation } from '@apollo/client';
import  { useContext, useEffect, useState } from 'react'
import { FETCH_USER_UPLIANCE_REVIEW } from '../app/graphql/queries';
import { useAppSelector } from '../app/store/hooks';
import { userIdSelector } from '../app/main/mainSlice';
import { CREATE_REFERRAL } from '../app/graphql/mutations';
import { ErrorManagementContext } from '../utils/errorManagement/ErrorManagementProvider';
import const_env from '../app/constants/env';
import { UseGetFlag } from '../app/launchDarkly';
import useLogRecipeEdit from './useLogRecipeEdit';



const useFetchReferralData = () => {
    const { cookClubLog } = useContext(ErrorManagementContext);
    const device = useAppSelector((state) => state.main.device);
    const [referralLink, setReferralLink] = useState<string | null>(null)
    const [referralId, setReferralId] = useState('')
    const { logRecipeEdit } = useLogRecipeEdit();


    const [insertReferralId] = useMutation(CREATE_REFERRAL, {
        onError: (err) => {
            cookClubLog(
                `Fectching User Linked Devices Failed`,
                "ERROR_ON_ACCESS_USER_LINKED_DEVICES",
                { err },
                { ui: { type: "error" }, browserConsole: true }
            );
        }
    });
    const userId = useAppSelector(userIdSelector);
    const [loading, setLoading] = useState<boolean>(true);
    const sessionId: string | undefined | null = sessionStorage.getItem("sessionId");
    const { referralString } = UseGetFlag();
    const {title, subtitle, amount } = referralString;

    function SnackbarText() {
        cookClubLog(
            "",
            "Copied referral link successfully!",
            '',
            { ui: { type: "info" }, browserConsole: true })
    }

    const logShareReferralLink = () => {
                logRecipeEdit("REFERRAL_LINK_COPIED", {});
                SnackbarText()
    }


    useEffect(() => {
        setLoading(true);

        const fetchData = async () => {
            const referralIdTemp = await insertReferralId({
                variables: { create_by: userId, expires_at: new Date(new Date().getTime() + (24 * 60 * 60 * 1000)) }
            })
    
            if (referralIdTemp?.data?.insert_refferal_link_one?.id) {
                logRecipeEdit( "APP_REFERRAL_GENERATE", {});
                
            }
            setLoading(false);
            setReferralLink(`${const_env.SHOP_BASE_URL}${referralIdTemp?.data?.insert_refferal_link_one?.id}`)
            setReferralId(referralIdTemp?.data?.insert_refferal_link_one?.id)

        }

        fetchData()
    }, [])
  return {referralLink, title, subtitle, amount, loading, logShareReferralLink}
}

export default useFetchReferralData;
